import { makeRequest } from 'utils/requestLogger';

export default (courseID, title, roundtable_id, premade_id, is_generated_by, sequence_id, draft_id) => {
  return makeRequest('post', '/api/live_discussions', {
    course_id: courseID,
    title,
    roundtable_id,
    premade_id,
    is_generated_by,
    sequence_id,
    draft_id
  }).then((res) => res.data);
};



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/createLiveDiscussion.js